import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/";
import Row from "./Row"
import TableHeader from "./tableHeader"
import Pagination from "../pagination";
import { loadPharmacies } from "../../redux/reducer/pharmaciesReducer";
import { useTranslation } from "react-i18next";

const PharmaciesTable = (props: any) => {
  const { pharmacies } = useSelector((state: any) => state);
  let result: any[] = pharmacies.listPharmacies;
  let search = pharmacies.search;
  let pageIndex = pharmacies.pageIndex;
  let pageTotal = pharmacies.pageTotal;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();


  const setPageIndex = (pageIndex: Number) => {
    dispatch(loadPharmacies(pageIndex))
  }

  return (

    <div className="row m-0">
      <div className="col-lg-12">
        <div className="Section">
          <table className="table">
            <TableHeader />
            <Row prenotation={result} />
          </table>
          <>
            {((result.length === 0 && !search) ?
              <p className="text-center">{t('error.not-pharmacies')}</p> : <></>)
            }
          </>
          <div className="col-12 mt-2 mb-2">
            {result.length !== 0 &&
              <>
                <Pagination
                  onPageChange={setPageIndex}
                  pageIndex={pageIndex}
                  pageTotal={pageTotal}
                />
              </>
            }
          </div>
        </div>
      </div>
    </div>

  )
}

export default PharmaciesTable